<script>
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import {contacts, requisites} from "@js/company_details.ts";
import {formatPhone} from "@js/helpers.ts";
import {Link} from "@inertiajs/vue3";

export default {
    name: "PublicOfferPage",
    components: {Link, MobileTopBar, Breadcrumbs},
    setup() {
        return {contacts, requisites, formatPhone};
    }
}
</script>

<template>
    <MobileTopBar/>

    <div class="container">
        <Breadcrumbs class="mb-2"/>

        <h1 class="text-2xl md:text-3xl">Публичная оферта ООО «ФУЛЛ СТРОЙ»</h1>
        <p class="text-sm text-gray-600 mt-2">Действует для сайта full-stroy.ru</p>

        <hr class="mt-5 mb-5"/>

        <div class="mb-10">
            <h2 class="text-xl font-medium mb-5">Основные понятия</h2>

            <p class="text-sm mb-2">
                <span class="font-bold text-base">Продавец</span> — ООО «ФУЛЛ СТРОЙ», ИНН {{ requisites.inn }},
                КПП {{ requisites.kpp }}, ОГРН {{ requisites.ogrn }}, юридический адрес:
                {{ requisites.ur_address }}.
            </p>

            <p class="text-sm mb-2">
                <span class="font-bold text-base">Сайт</span> — интернет-сайт
                <strong>https://full-stroy.ru</strong>, на котором размещена информация о товарах, услугах, оплате,
                доставке и порядке оформления заявок.
            </p>

            <p class="text-sm mb-2">
                <span class="font-bold text-base">Покупатель</span> — физическое лицо, юридическое лицо или
                индивидуальный предприниматель, оформивший заявку, заказ или согласовавший покупку товара с Продавцом.
            </p>

            <p class="text-sm mb-2">
                <span class="font-bold text-base">Товар</span> — строительные материалы и сопутствующая продукция:
                железобетонные изделия, бетонные и растворные смеси, пиломатериалы, тротуарная плитка, нерудные
                материалы, строительные конструкции, а также иные товары, представленные на сайте или согласованные
                сторонами отдельно.
            </p>

            <p class="text-sm mb-2">
                <span class="font-bold text-base">Заказ</span> — заявка Покупателя на приобретение товара, оформленная
                через сайт, по телефону, электронной почте, в мессенджере или иным согласованным способом.
            </p>

            <p class="text-sm mb-2">
                <span class="font-bold text-base">Спецификация</span> — согласованные сторонами наименование товара,
                количество, характеристики, цена, сроки, условия оплаты, доставки и разгрузки.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">1. Общие положения</h2>

            <p class="text-sm mb-2">
                1.1. Настоящий документ является публичной офертой в соответствии со статьёй 435 и пунктом 2 статьи 437
                Гражданского кодекса РФ.
            </p>

            <p class="text-sm mb-2">
                1.2. Оформляя заказ, направляя заявку, оплачивая счёт либо подтверждая заказ по телефону или электронной
                почте, Покупатель принимает условия настоящей Оферты.
            </p>

            <p class="text-sm mb-2">
                1.3. Если между сторонами заключён отдельный договор, подписана спецификация или выставлен счёт с
                особыми условиями, такие документы имеют приоритет в соответствующей части.
            </p>

            <p class="text-sm mb-2">
                1.4. Продавец вправе изменять Оферту в одностороннем порядке. Новая редакция действует с момента
                публикации на сайте, если иной срок не указан отдельно.
            </p>

            <p class="text-sm mb-2">
                1.5. Цены, наличие, сроки поставки и характеристики на сайте носят информационный характер и подлежат
                подтверждению менеджером.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">2. Оформление заказа</h2>

            <p class="text-sm mb-2">
                2.1. Заказ может быть оформлен через сайт, по телефону {{ formatPhone(contacts.sales_department_phone) }},
                по e-mail {{ contacts.info_mail }} или через иные каналы связи, используемые Продавцом.
            </p>

            <p class="text-sm mb-2">
                2.2. Покупатель обязан предоставить достоверные данные: контактное лицо, телефон, e-mail, адрес доставки,
                реквизиты организации, перечень товаров, требуемое количество и иные сведения, необходимые для расчёта
                и поставки.
            </p>

            <p class="text-sm mb-2">
                2.3. Заказ считается согласованным после подтверждения Продавцом наличия, цены, условий оплаты, доставки,
                сроков поставки и иных существенных условий.
            </p>

            <p class="text-sm mb-2">
                2.4. Продавец вправе отказать в исполнении заказа при отсутствии товара, невозможности поставки,
                некорректных данных Покупателя, отсутствии оплаты или по иным объективным причинам.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">3. Товар и характеристики</h2>

            <p class="text-sm mb-2">
                3.1. Изображения товаров на сайте являются иллюстративными и могут отличаться от фактического внешнего
                вида товара.
            </p>

            <p class="text-sm mb-2">
                3.2. Характеристики, размеры, масса, объём, оттенок, фактура, упаковка и комплектация могут иметь
                допустимые отклонения в пределах ГОСТ, ТУ, технической документации производителя или условий поставки.
            </p>

            <p class="text-sm mb-2">
                3.3. По бетонным и растворным смесям марка, класс, подвижность, морозостойкость, водонепроницаемость,
                добавки, объём и время подачи согласуются до отгрузки.
            </p>

            <p class="text-sm mb-2">
                3.4. По ЖБИ, пиломатериалам, тротуарной плитке, нерудным материалам и строительным конструкциям
                количество, габариты, сортность, прочность, комплектация и иные параметры фиксируются в счёте,
                спецификации или переписке сторон.
            </p>

            <p class="text-sm mb-2">
                3.5. Сертификаты, паспорта качества, декларации соответствия и иная документация предоставляются при
                наличии у производителя, поставщика или склада.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">4. Цена и порядок оплаты</h2>

            <p class="text-sm mb-2">
                4.1. Цены указываются в рублях РФ. Наличие НДС или его отсутствие указывается в счёте, договоре или
                ином расчётном документе.
            </p>

            <p class="text-sm mb-2">
                4.2. Доступные способы оплаты: безналичная оплата по счёту, оплата банковской картой при наличии
                технической возможности, наличная оплата в случаях, согласованных с Продавцом.
            </p>

            <p class="text-sm mb-2">
                4.3. Счёт или коммерческое предложение действует в течение срока, указанного в документе. Если срок не
                указан, цена подлежит дополнительному подтверждению менеджером перед оплатой.
            </p>

            <p class="text-sm mb-2">
                4.4. Продавец вправе изменить цену до момента оплаты, если изменились рыночные условия, стоимость
                логистики, наличие товара, параметры заказа или условия поставки.
            </p>

            <p class="text-sm mb-2">
                4.5. После оплаты согласованного заказа цена не меняется, кроме случаев изменения спецификации по
                инициативе Покупателя или наступления обстоятельств, прямо предусмотренных договором.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">5. Доставка и разгрузка</h2>

            <p class="text-sm mb-2">
                5.1. Условия доставки указаны на странице
                <Link :href="route('deliveryAndShipping')" class="underline hover:text-navHoverColor leading-tight transition font-bold">
                    «Доставка и отгрузка»
                </Link>
                и дополнительно согласуются при оформлении заказа.
            </p>

            <p class="text-sm mb-2">
                5.2. Доставка может осуществляться транспортом Продавца, привлечёнными перевозчиками, транспортными
                компаниями либо самовывозом Покупателя.
            </p>

            <p class="text-sm mb-2">
                5.3. Стоимость доставки зависит от адреса, зоны, массы, объёма, габаритов, типа транспорта, времени
                подачи, условий разгрузки и дополнительных услуг.
            </p>

            <p class="text-sm mb-2">
                5.4. Разгрузка, подготовка подъездных путей, пропуска, доступ на объект, место для манёвра транспорта,
                кран, манипулятор, погрузчик и рабочая сила обеспечиваются Покупателем, если иное не согласовано
                сторонами.
            </p>

            <p class="text-sm mb-2">
                5.5. Риск случайной гибели или повреждения товара переходит к Покупателю с момента передачи товара
                Покупателю, его представителю, перевозчику или транспортной компании, если иное не согласовано сторонами.
            </p>

            <p class="text-sm mb-2">
                5.6. Простой транспорта, повторная подача, изменение адреса, ожидание пропуска, невозможность разгрузки
                и иные дополнительные расходы оплачиваются Покупателем.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">6. Приёмка товара</h2>

            <p class="text-sm mb-2">
                6.1. Покупатель обязан проверить товар по количеству, ассортименту, комплектности и видимым повреждениям
                при получении.
            </p>

            <p class="text-sm mb-2">
                6.2. Все расхождения фиксируются в товарной накладной, УПД, акте приёмки, акте транспортной компании
                или ином документе в момент получения товара.
            </p>

            <p class="text-sm mb-2">
                6.3. При отсутствии замечаний при получении товар считается переданным в надлежащем количестве,
                ассортименте и внешнем состоянии, кроме скрытых недостатков.
            </p>

            <p class="text-sm mb-2">
                6.4. Скрытые недостатки рассматриваются после получения письменного обращения, документов по заказу и
                подтверждающих материалов.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">7. Возврат товара и денежных средств</h2>

            <p class="text-sm mb-2">
                7.1. Условия возврата и обмена указаны на странице
                <Link :href="route('returnGuarantee')" class="underline hover:text-navHoverColor leading-tight transition font-bold">
                    «Обмен, возврат и гарантия»
                </Link>.
            </p>

            <p class="text-sm mb-2">
                7.2. Возврат товара надлежащего качества возможен только при сохранении товарного вида, упаковки,
                маркировки, документов и при отсутствии следов использования, монтажа или обработки.
            </p>

            <p class="text-sm mb-2">
                7.3. Не подлежат возврату товары, изготовленные или обработанные под индивидуальные требования
                Покупателя, а также бетонные и растворные смеси после отгрузки.
            </p>

            <p class="text-sm mb-2">
                7.4. При возврате товара надлежащего качества расходы на доставку, погрузку, разгрузку, хранение и иные
                фактические расходы несёт Покупатель.
            </p>

            <p class="text-sm mb-2">
                7.5. Возврат денежных средств производится в порядке и сроки, установленные законодательством РФ,
                договором или соглашением сторон.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">8. Ответственность сторон</h2>

            <p class="text-sm mb-2">
                8.1. Продавец не несёт ответственность за убытки, возникшие вследствие неправильного выбора товара,
                нарушения условий хранения, разгрузки, монтажа, эксплуатации или применения товара Покупателем.
            </p>

            <p class="text-sm mb-2">
                8.2. Покупатель несёт ответственность за достоверность предоставленных данных, готовность объекта к
                приёмке товара, наличие подъездных путей, пропусков и условий для безопасной разгрузки.
            </p>

            <p class="text-sm mb-2">
                8.3. Продавец не отвечает за задержки, вызванные действиями перевозчиков, дорожной ситуацией,
                погодными условиями, ограничениями движения, действиями государственных органов и иными обстоятельствами,
                не зависящими от Продавца.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">9. Персональные данные</h2>

            <p class="text-sm mb-2">
                9.1. Персональные данные Покупателя обрабатываются в соответствии с Политикой конфиденциальности,
                размещённой на сайте.
            </p>

            <p class="text-sm mb-2">
                9.2. Передавая данные через сайт, по телефону, электронной почте или в мессенджере, Покупатель
                соглашается на их обработку для оформления заказа, расчёта стоимости, доставки, оплаты, документооборота
                и клиентской поддержки.
            </p>

            <p class="text-sm mb-2">
                9.3. Для отказа от рекламных сообщений можно обратиться по телефону
                {{ formatPhone(contacts.sales_department_phone) }} или на e-mail {{ contacts.info_mail }}.
                Сервисные уведомления по заказу могут направляться независимо от рекламной подписки.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">10. Форс-мажор</h2>

            <p class="text-sm mb-2">
                Стороны освобождаются от ответственности за полное или частичное неисполнение обязательств, если оно
                вызвано обстоятельствами непреодолимой силы: пожарами, авариями, стихийными бедствиями, ограничениями
                движения, перебоями поставок, действиями органов власти, военными действиями, забастовками, эпидемиями,
                сбоями связи и иными обстоятельствами вне разумного контроля сторон.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">11. Разрешение споров</h2>

            <p class="text-sm mb-2">
                11.1. Все споры стороны стремятся урегулировать путём переговоров и обмена документами.
            </p>

            <p class="text-sm mb-2">
                11.2. При невозможности урегулировать спор в претензионном порядке спор передаётся на рассмотрение в
                суд в соответствии с законодательством РФ.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl mb-5 font-medium">12. Заключительные положения</h2>

            <p class="text-sm mb-2">
                12.1. Недействительность одного из положений Оферты не влечёт недействительность остальных положений.
            </p>

            <p class="text-sm mb-2">
                12.2. Продавец вправе привлекать третьих лиц для исполнения обязательств перед Покупателем, оставаясь
                ответственным в пределах применимого законодательства и согласованных условий.
            </p>

            <p class="text-sm mb-2">
                12.3. К отношениям сторон применяется законодательство Российской Федерации.
            </p>
        </div>

        <div class="mb-6">
            <h2 class="text-xl mb-5 font-medium">13. Реквизиты и контакты Продавца</h2>

            <p class="text-sm mb-2">
                ООО «ФУЛЛ СТРОЙ»<br>
                ИНН: {{ requisites.inn }}<br>
                КПП: {{ requisites.kpp }}<br>
                ОГРН: {{ requisites.ogrn }}<br>
                Юридический адрес: {{ requisites.ur_address }}
            </p>

            <p class="text-sm mb-2">
                Тел.: {{ formatPhone(contacts.sales_department_phone) }}<br>
                E-mail: {{ contacts.info_mail }}<br>
                Сайт: full-stroy.ru
            </p>
        </div>
    </div>
</template>

<style scoped lang="scss">
.prose a {
    @apply text-yellow-600 hover:text-yellow-800 underline;
}
</style>
